import requestAction from '../../utils/requestAction'
import ProductBrand from '../../models/ProductBrand';

export const upsertProductBrand = (productBrand: (ProductBrand)) =>
  requestAction('PRODUCTBRAND_UPSERT')(
    `productBrands${(productBrand as ProductBrand).id ? `/${(productBrand as ProductBrand).id}` : ''}`,
    (productBrand as ProductBrand).id ? 'PUT' : 'POST',
    productBrand
  )
